// app/parametri/parametri.js

(function () {
    'use strict';
    var controllerId = 'parametri';
    angular.module('app').controller(controllerId, ['$rootScope', '$scope', '$routeParams', '$location', '$filter', 'common', 'bootstrap.dialog', '$uibModal', 'datacontext', 'sectionMenu', '$translate', 'tmhDynamicLocale', 'amMoment', parametriFn]);

    function parametriFn($rootScope, $scope, $routeParams, $location, $filter, common, bDialog, $uibModal, datacontext, sectionMenu, $translate, tmhDynamicLocale, amMoment) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this, onRouteChangeOff;
        vm.title = 'Parametri';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);                
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.addDisabled = true;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        vm.super = $rootScope.isAuthorized('SUPER');       
        vm.lingua = [{ name: $translate.instant('Italiano'), value: 'it' }, { name: $translate.instant('Inglese'), value: 'en' }];
                
        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['azienda'];
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
        };
        
        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;              
        vm.getRecord = getRecord;        
        vm.get = getRecord;        

        //Gestione parametri     
        vm.edit = editParametri;
        vm.delete = deleteParametri;

        vm.item = {};
        vm.changed = false;
        vm.change = 0;
        vm.confirmRoute = confirmRoute;
        
        vm.modalEdit = modalEdit;
        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [];
            common.activateController(promises, controllerId)
                .then(function () {
                    if ($routeParams.parametriId != null) {
                        setView('detail');
                        getRecord($routeParams.parametriId, 0);
                    }
                });
        }

        //****************************************************
        /*CONFIRM SAVE BEFORE CHANGE ROUTE */
        //****************************************************
        function init() {
            //initialize data here..    
            vm.item.editForm = false;

            //Make sure they"re warned if they made a change but didn"t save it
            //Call to $on returns a "deregistration" function that can be called to
            //remove the listener (see routeChange() for an example of using it)
            onRouteChangeOff = $scope.$on("$locationChangeStart", routeChange);
        }
        init();

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            if (view == 'list')
                cerca();
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.settings_countAll().then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.settings_getAll(vm.pageSize, vm.page, vm.ordine).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    vm.records.push.apply(vm.records, data);                   
                }
                vm.loading = false;               
            });            
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {            
            return datacontext.settings_get(id).then(function (data) {                
                vm.index = index;
                vm.record = data;                

                setView('detail');
            });
        } 

        function confirmRoute(event, newUrl) {
            var attempt = true;

            if (vm.recordForm)
                vm.item.editForm = vm.recordForm.$dirty;

            if (vm.item.editForm) {
                bDialog.confirmationDialog($translate.instant('Modifiche non salvate'), $translate.instant('Sono presenti modifiche non salvate'), $translate.instant('Salva modifiche e procedi'), $translate.instant('Annulla modifiche e procedi')).then(function () { //YES
                    if (vm.recordForm.$valid) {
                        vm.edit(vm.recordForm.$event);

                        vm.item.editForm = false;
                        onRouteChangeOff(); //Stop listening for location changes

                        if (newUrl == '') {
                            if(vm.super)
                                $location.url("/parametri");
                        }
                        else
                            $location.path($location.url(newUrl).hash()); //Go to page they're interested in                    

                        return attempt;
                    } else {
                        logError($translate.instant('Compilare i campi obbligatori'));
                        return attempt;
                    }
                }, function (btn) { // NO
                    vm.item.editForm = false;
                    onRouteChangeOff(); //Stop listening for location changes

                    if (newUrl == '') {
                        if (vm.super)
                            $location.url("/parametri");
                    }
                    else
                        $location.path($location.url(newUrl).hash()); //Go to page they're interested in                    

                    vm.change = 0;
                    return attempt;
                });
            }
            else {
                attempt = false;
                vm.item.editForm = false;
                onRouteChangeOff(); //Stop listening for location changes
                if (newUrl == '') {
                    if (vm.super)
                        $location.url("/parametri");

                    vm.index = 0;
                }
                else
                    $location.path($location.url(newUrl).hash()); //Go to page they're interested in   
            }

            return attempt;
        }

        function routeChange(event, newUrl, oldUrl) {
            vm.change++;
            if (vm.change == 1) {
                if (confirmRoute(event, newUrl, vm.recordForm)) {
                    event.preventDefault();
                    return;
                }
            }
        }

        function editParametri() {
            if (vm.record.bSezioni)
                vm.record.FiltroCommesse = false;

            return datacontext.settings_update(vm.record).then(function (data) {
                if (data != 400 && data != 404) {
                    if (vm.recordForm)
                        vm.recordForm.$setPristine();
                    logSuccess($translate.instant('Dato salvato'));

                    amMoment.changeLocale(data.Lingua);
                    tmhDynamicLocale.set(data.Lingua);

                    window.location.reload();
                }
                else {
                    logError($translate.instant('Impossibile salvare il dato'));
                }
            });
        }

        function modalEdit(item, index) {
            var modalParametri = {};
            angular.copy(item, modalParametri);
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/parametri/modal/parametriAddEdit.html?version=30',
                controller: 'parametriAddEdit',
                resolve: {
                    parametri: function () {
                        return modalParametri;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError('Errore durante la modifica del dato ');

                logSuccess($translate.instant('Parametri aggiunti con successo'));
                vm.cerca();
            });
        }

        function deleteParametri(item) {
            var msg = " " + $translate.instant('i parametri') + " "
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.settings_delete(item.Id).then(function (data) {
                    if (!data) return logError($translate.instant('Errore durante la rimozione del dato'));
                    var index = vm.records.indexOf(item)
                    vm.records.splice(index, 1);
                    vm.countRecords--;
                });
            });
        }
    }
})();
